import axios from "../api/axios";

// 获取SystemList
export const getSystemList = ({ commit }, data) => {
    return axios.get(
        '/api/getSystemList',
        {headers:{"Content-Type":"application/json"}}
    )
};

//获取DownloadHistoryByPerson
export const historybyperson = ({ commit }, data) => {
        return axios.get(
            '/api/download/historybyperson',
            {headers:{"Content-Type":"application/json"}}
        )
    };

//获取模块系统
export const getModuleSystemn=({commit}, data) => {
    return axios.get(
        '/api/getModuleSystemn',
        {headers:{"Content-Type":"application/json"}}
    )
};
// 用户登录
export const login = ({ commit }, data) => {
    return axios.post(
        '/api/login',
        {
            UserName: data.username, Password: data.password 
        },
        {headers:{"Content-Type":"application/json"}}
    )
};
//修改密码
export const changePassword = ({ commit }, data) => {
    return axios.post(
        '/api/reviseInformation',
        {
            oldPassword: data.oldPassword, newPassword: data.newPassword 
        },
        {headers:{"Content-Type":"application/json"}}
    )
};
//退出登录
export const signOut=({commit})=>{
    return axios.post(
        '/api/logout',
        {headers:{"Content-Type":"application/json"}}
    )
}
//判断是否登录
export const isLogin=({commit})=>{
    return axios.get(
        '/api/userstate'
    )
}




// export const nuxtServerInit = function({commit}, { req }){
//     debugger
//     if (req.session.user) {
//         let userInfo = {UserName:req.session.user.UserName,ip:req.ip}
//         commit('setUserInfo', userInfo)
//     }
// }